import React from 'react';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import {BasicEvent} from 'util/Types';

export default function InformationPanelNameInput(props: {
  isWritable: boolean;
  onChange: (e: BasicEvent) => void;
  id: string;
  name: string;
  archiveRecord: ArchiveRecord | null;
}): JSX.Element {
  return (
    <div>
      {props.isWritable ? (
        <input
          id="info-name"
          type="text"
          className="info-name-input"
          onChange={props.onChange}
          value={props.name}
        />
      ) : (
        props.name
      )}
      <ArchiveRecordLabel item={{id: props.id, archiveRecord: props.archiveRecord, name: props.name}} />
    </div>
  );
}
